export const hotelBoardTypes = ['RO', 'BB', 'HB', 'FB'];
